import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { TrustRouteSegmentsEnum } from '@app/trust/shared/enums';

@Injectable({ providedIn: 'root' })
export class TrustStartNavigationService {
  private readonly _router = inject(Router);
  private readonly _tenancy = inject(TenancyContext);

  public goToTrustInfo() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.TRUST,
        TrustRouteSegmentsEnum.Start,
        TrustRouteSegmentsEnum.TrustInformation,
      ),
    ]);
  }

  public goToAccount() {
    this._router.navigate([
      this._tenancy.link(
        TenantKey.TRUST,
        TrustRouteSegmentsEnum.Start,
        TrustRouteSegmentsEnum.Account,
      ),
    ]);
  }

  public goBack() {
    this._router.navigate([this._tenancy.link('public', 'access', 'login')]);
  }
}
